// extracted by mini-css-extract-plugin
export var dataCell = "_p8-2";
export var dataRow = "_p8-0";
export var headerRow = "_p8-1";